import { Fragment } from 'react';
import RenderIf from 'components/RenderIf/RenderIf';
import { NSCard } from 'bricks';
import {
    HIGHLIGHTED_SUBTITLES, cardRowClass, infoSubtitleRowClass, infoTitleClass, infoValueClass,
} from '../constants';

export interface IBackOfEnvelopeKeyValuesSectionProps {
    title: string;
    subtitles: { label: string; value: number | string }[];
    searchTerm: string;
}

const BackOfEnvelopeKeyValuesSection = ({ title, subtitles, searchTerm }: IBackOfEnvelopeKeyValuesSectionProps) => {
    const searchTermLower = searchTerm.toLowerCase().trim();

    const titleMatches = title.toLowerCase().includes(searchTermLower);
    const matchingSubtitles = subtitles.filter(sub => sub.label.toLowerCase().includes(searchTermLower));

    if (!searchTerm || titleMatches || matchingSubtitles.length > 0) {
        const subsToRender = !searchTerm || titleMatches ? subtitles : matchingSubtitles;

        return (
            <div className="mb-3">
                <div className={infoTitleClass}>{title}</div>
                {subsToRender.map(sub => (
                    <Fragment key={sub.label}>
                        <RenderIf isTrue={HIGHLIGHTED_SUBTITLES.includes(sub.label)}>
                            <NSCard className="NSCard--level-4 py-1 mb-1">
                                <div className={cardRowClass}>
                                    <span>
                                        {sub.label}
                                        :
                                    </span>
                                    <span className={infoValueClass}>{sub.value}</span>
                                </div>
                            </NSCard>
                        </RenderIf>

                        <RenderIf isTrue={!HIGHLIGHTED_SUBTITLES.includes(sub.label)}>
                            <div className={infoSubtitleRowClass}>
                                <span>
                                    {sub.label}
                                    :
                                </span>
                                <span className={infoValueClass}>{sub.value}</span>
                            </div>
                        </RenderIf>
                    </Fragment>
                ))}
            </div>
        );
    }

    return null;
};

export default BackOfEnvelopeKeyValuesSection;
